import { render, staticRenderFns } from "./DashboardSquare.vue?vue&type=template&id=22d58159&"
import script from "./DashboardSquare.vue?vue&type=script&lang=js&"
export * from "./DashboardSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports